module.exports = __webpack_public_path__ + "images/da3c2697cbe5c85299acd4a20d021410-trendingImg5.png";